export type ProductSelectionValue = ProductSelection[] | null;

export type ProductSelection = 'asset-finance' | 'business-loan' | 'insurance-premium';
